module.exports = __webpack_public_path__ + "static/media/women-photographer-wide-bg_001_2000px.2ce87008.png";